<div class="spinner-container"></div>
<div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
</div>
